// extracted by mini-css-extract-plugin
export default {"inbox":"Inbox__inbox--3Nx"};